var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Font, TextElement } from "./TextElement";
import { ScreenSize, useScreenSize } from "../util/MediaQueries";
const BUTTON_COLOR_MAP = {
    pink: {
        primaryColor: '#FFB3DE',
        primaryColorHighlighted: '#FFC7E7',
        secondaryColor: '#FFF4FB',
        secondaryColorHighlighted: '#FFF8FD',
    },
    blue: {
        primaryColor: '#5DE8FF',
        primaryColorHighlighted: '#A2F2FF',
        secondaryColor: '#EBFCFF',
        secondaryColorHighlighted: '#F3FDFF',
    },
    black: {
        primaryColor: '#000000',
        primaryColorHighlighted: '#444444',
        secondaryColor: '#DCDCDC',
        secondaryColorHighlighted: '#F2F2F2',
    }
};
export const Button = (props) => {
    const screenSize = useScreenSize();
    const { children, variant, style, text, fontSize, color, fontWeight } = props, rest = __rest(props, ["children", "variant", "style", "text", "fontSize", "color", "fontWeight"]);
    const { disabled } = rest;
    const { primaryColor, primaryColorHighlighted, secondaryColor, secondaryColorHighlighted } = BUTTON_COLOR_MAP[color];
    const textColor = variant === 'primary' ? '#FFFFFF' : "#000000";
    const disabledBackgroundColor = variant === 'primary' ? '#CCCCCC' : '#EEEEEE';
    return (_jsxs("button", Object.assign({ className: 'button', type: 'button' }, rest, { style: Object.assign({ borderStyle: variant === 'primary' ? 'none' : 'solid', borderWidth: variant === 'primary' ? undefined : screenSize === ScreenSize.Large ? '3px' : '2px', borderColor: disabled ? '#CCCCCC' : variant === 'primary' ? undefined : primaryColor, ['--hover-border-color']: disabled ? '#CCCCCC' : variant === 'primary' ? undefined : primaryColorHighlighted, ['--hover-background-color']: disabled ? disabledBackgroundColor : variant === 'primary' ? primaryColorHighlighted : secondaryColorHighlighted, borderRadius: screenSize === ScreenSize.Large ? '12px' : '8px', backgroundColor: disabled ? disabledBackgroundColor : variant === 'primary' ? primaryColor : secondaryColor, cursor: 'pointer' }, style), children: [text && _jsx(TextElement, { font: Font.Inter, text: text, color1: textColor, fontSize: fontSize, fontWeight: fontWeight }), children] })));
};
//# sourceMappingURL=Button.js.map